import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { useMemo } from 'react';
// import {
//   DogeCoinIcon,
//   EtheriumIcon,
//   GelIcon,
//   LitecoinIcon,
//   TronCoinIcon,
//   UsdIcon,
//   PepeCoinIcon,
//   BitcoinIcon,
//   ShibaIcon,
//   UsdtIcon,
//   XrpIcon,
//   CardanoIcon,
//   PolkadotIcon,
//   StepnIcon,
//   GreenSatoshiTokenIcon,
// } from '../assets';
// Restyled ICONS
const defaultSizeStyles = css `
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`;
const CurrencyIconImg = styled.img `
  ${defaultSizeStyles}
`;
export const useCurrencyIcons = (size = '3.1rem', assets) => {
    return useMemo(() => {
        if (assets && assets.length > 0) {
            return assets.reduce((acc, curr) => {
                acc[curr.code] = (_jsx(CurrencyIconImg, { src: curr.iconUrl, size: size, className: "currency_icon" }));
                return acc;
            }, {});
        }
        return {};
    }, [assets, size]);
};
//# sourceMappingURL=useCurrencyIcons.js.map